import { useStore } from '@/store'
import AuthService from '@/services/AuthService'

export default nuxtApp => {
  const { $pinia } = nuxtApp
  const store = useStore($pinia)

  return {
    async get (path) {
      return await $fetch(`${store.config.platformUrl}${path}`, {
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${store.token}`
        }
      }).catch(e => {
        if (e.response?.status === 401) {
          AuthService.setupGuestUser(store, nuxtApp.$i18n)
        }
      })
    },
    authorise () {
      return this.get('/account/gotohelpcenter/jwt')
    },
    getNavigationBarData () {
      return this.get('/external/userdata.json')
    }
  }
}
